/* eslint-disable @typescript-eslint/prefer-literal-enum-member -- this information comes from the backend to store it as bitfields */

export enum LoginStatus {
  LoggedOut = 0,
  LoggedInPractice = 1 << 0,
  LoggedInPatient = 1 << 1,
}

/* eslint-enable @typescript-eslint/prefer-literal-enum-member -- reenable */
